import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { forwardRef, memo, } from 'react';
import styles from './DefaultOptionList.css';
function DefaultOptionListBase(props, ref) {
    const { children, onMouseOut, className } = props;
    return (_jsx("ul", Object.assign({ ref: ref, className: classnames(styles.layout, className), onMouseOut: onMouseOut, onBlur: onMouseOut, "data-testid": "search-box-options" }, { children: children }), void 0));
}
export default memo(forwardRef(DefaultOptionListBase));
